export const canUndoReviseProduct = () => () => {
    return function (nodes) {
        return [...nodes].filter(
            node => this.actions.canUndoReviseProduct(node)
        )
    }
}

export const undoReviseProduct = () => {
    return () => async function (nodes) {
        await this.execute(
            () => this.runParallelAction(
                () => this.actions.undoReviseProduct(nodes),
                {action: '撤销修订模型制品'},
            )
        )
    }
}
